export default {"src":"/statics/ecommerce/_next/static/media/logo-younited.9a7bcf25.svg","height":48,"width":210,"blurWidth":0,"blurHeight":0};